export default __webpack_public_path__ + "static/media/slide13.d24d9b44.jpg";